import { FieldSizeType } from "@/components/@types";
import { Values } from "@/constants/values";

export function useSizing(size: FieldSizeType = "md") {
  return {
    cellStyles: {
      minHeight:
        size === "md"
          ? Values.DEFAULT_ROW_HEIGHT * 0.92
          : Values.DEFAULT_ROW_HEIGHT * 0.72,
      paddingTop: size === "md" ? "4px" : "4px",
      paddingBottom: size === "md" ? "4px" : "4px",
      paddingLeft: size === "md" ? "8px" : "4px",
      paddingRight: size === "md" ? "8px" : "4px",
    },
  };
}
